import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { getReplacementSaveBlockers } from "./getReplacementSaveBlockers";
import { ISaveBlocker } from "./interface";

/**
 * Derives the single replacement save blockers from a hierarchy.
 *
 * @param hierarchy - The hierarchy whose singles are validated, or null when none is loaded.
 * @returns The blockers for the hierarchy's singles (empty when there is no hierarchy).
 */
export const getSinglesSaveBlockers = (hierarchy: HierarchyReadDto | null): Set<ISaveBlocker> =>
  getReplacementSaveBlockers(
    hierarchy?.singles ?? [],
    (a, b) => a.oldText === b.oldText,
    "singles",
  );
